"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slot = void 0;
const superstruct_1 = require("superstruct");
const appointment_1 = require("./appointment");
/*
 [Time]Slot is a virtual collection of appointmens in a given time
*/
exports.Slot = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    key: (0, superstruct_1.string)(),
    label: (0, superstruct_1.string)(),
    disabled: (0, superstruct_1.boolean)(),
    startTime: (0, superstruct_1.date)(),
    endTime: (0, superstruct_1.date)(),
    occupancy: (0, superstruct_1.number)(),
    appointments: (0, superstruct_1.array)(appointment_1.AppointmentShortStruct),
    serviceId: (0, superstruct_1.string)(),
    shopCapacity: (0, superstruct_1.number)(),
});
exports.Slot.type = 'Slot';
//# sourceMappingURL=slot.js.map